import { render, staticRenderFns } from "./TOS.vue?vue&type=template&id=5b803210&scoped=true&"
import script from "./TOS.vue?vue&type=script&lang=ts&"
export * from "./TOS.vue?vue&type=script&lang=ts&"
import style0 from "./TOS.vue?vue&type=style&index=0&id=5b803210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b803210",
  null
  
)

export default component.exports